import { fromJS } from 'immutable';
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom';
import { getStorageValue, StorageFields } from '../../../storage/browserStorage';
import { Card, getCardDimensions } from './card'

/**
 * @param table: Table
 * @param hand: Immutable Hand
 * @param parentWidth: Number
 * @param parentHeight: Number
 * @param send: WS
 * @param isOwnTurn: Bool
 * @param isPlaying: Bool
 * @param highlightedCards: Map
 */
class Hand extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            animatePlayCard: undefined,
            preMove: undefined,
            hoverIdx: undefined,
            cardPointer: undefined,
        }
        this._cardTopY = undefined
        this._lastHoveredCard = null
        this._lastCardPointer = null
        this._lastCardPointerChange = -1

        this._keyboardListener = window.addEventListener("keydown", evt => {
            if (!window._isChatOpen && this.props.table.get("status") == "ACTIVE" && this.props.isPlaying) {
                let cardsPlayable = this.getCards().map(this.isCardPlayable.bind(this))
                if (["ArrowLeft", "ArrowRight", "ArrowDown"].includes(evt.key)
                    && cardsPlayable.size > 0
                    && (new Date().getTime() - this._lastCardPointerChange) > 50) {
                    let doPlayableCardsExist = cardsPlayable.includes(true)
                    if (this.state.cardPointer != null && evt.key !== "ArrowDown") {
                        let direction = evt.key == "ArrowLeft" ? -1 : 1
                        for (var j = 1; j < cardsPlayable.size; j++) {
                            let idx = this.state.cardPointer + direction * j
                            if (idx < 0) {
                                idx = cardsPlayable.size + idx
                            } else if (idx >= cardsPlayable.size) {
                                idx -= cardsPlayable.size
                            }
                            if (!doPlayableCardsExist || cardsPlayable.get(idx)) {
                                this.setState({ cardPointer: idx })
                                break;
                            }
                        }
                    } else if (this.state.cardPointer == null) {
                        let idx = doPlayableCardsExist ? cardsPlayable.findIndex(v => !!v) : 0
                        this.setState({ cardPointer: this._lastCardPointer != null ? Math.min(this._lastCardPointer, cardsPlayable.size - 1) : 0 })
                    }
                    this._lastCardPointerChange = new Date().getTime()
                } else if (evt.key == "Enter" && this.state.cardPointer != null) {
                    let ptr = this.state.cardPointer
                    if (this.isCardPlayable(this.getCards().get(ptr))) {
                        this.handlePlayCard(ptr)
                    } else if (getStorageValue(StorageFields.PRE_MOVES) !== "none") {
                        this.setState({ preMove: this.state.preMove == ptr ? null : ptr })
                    }
                } else if (["ArrowUp", "Backspace"].includes(evt.key)) {
                    this.setState({ cardPointer: null })
                }
            }
        })
    }

    getCards(props = this.props)
    {
        return props.hand.get("cards")
    }

    isCardPlayable(card)
    {
        return this.props.table.get("playableCards").includes(card) && this.props.isPlaying
    }

    componentWillReceiveProps(nextProps)
    {
        if (this.state.animatePlayCard != null && nextProps.table && this.props.table
            && nextProps.table.get("currentTrick").size != this.props.table.get("currentTrick").size) {
            this.setState({ animatePlayCard: undefined })
        }
    }

    componentDidUpdate(prevProps, prevState)
    {
        if (this.state.preMove != null && getStorageValue(StorageFields.PRE_MOVES) === "none") {
            this.setState({ preMove: null })
        }

        if (prevState.cardPointer != null && this.state.cardPointer == null) {
            this._lastCardPointer = prevState.cardPointer
        }

        const sendNotification = () => {
            if (document.hidden && window.Notification && Notification.permission === "granted") {
                const notification = new Notification(
                    Messages("table.notifications.on-turn"),
                    { body: Messages("chat.messages.12") });
                notification.onclick = () => {
                    window.focus()
                    notification.close()
                };
            }
        }

        if (!prevProps.isOwnTurn && this.props.isOwnTurn) {

            if (this.state.preMove != null) {
                const isPlayable = this.props.table.get("playableCards").includes(this.getCards().get(this.state.preMove))
                if (isPlayable) {
                    let delay = 1;
                    if (this.props.table.get("currentTrick").size > 0 && this.getCards().size > 1
                        && getStorageValue(StorageFields.PRE_MOVES) === "natural") {
                        delay = 200 + (Math.random() * 1000)
                    }
                    this.setState({ preMoveDelay: delay, preMoveStart: new Date().getTime() }, () => {
                        setTimeout(() => {
                            if (this.state.preMove != null) {
                                this.handlePlayCard(this.state.preMove)
                                this.setState({ preMoveDelay: null, preMoveStart: null, preMove: null })
                            }
                        }, delay)
                    })
                } else {
                    this.setState({ preMove: null })
                    sendNotification()
                }
            } else {
                sendNotification()
            }

            // Move cardPointer if needed
            if (this.state.cardPointer != null && !this.isCardPlayable(this.getCards().get(this.state.cardPointer))) {
                let nextPointerIdx = this.getCards().size > 0
                    ? this.getCards().map((c, idx) => [ c, idx, Math.abs(this.state.cardPointer - idx) ])
                        .sort((a, b) => a[2] - b[2]).find(e => this.isCardPlayable(e[0]))[1]
                    : null
                this.setState({ cardPointer: nextPointerIdx })
            }
        }
    }

    handlePlayCard(idx)
    {
        this.setState({
            animatePlayCard: idx,
            preMove: null,
            preMoveStart: null,
            preMove: null,
            hoverIdx: undefined,
            cardPointer: this.state.cardPointer == idx ? null : this.state.cardPointer
        }, () => setTimeout(
            () => this.props.send({
                type: "PLAY_CARD",
                card: this.getCards().get(idx)
            }),
            310
        ))
    }

    handleMouseEnter(idx)
    {
        this.setState({ hoverIdx: idx })
        if (this._lastHoveredCard != idx) {
            this.props.send({
                type: "HOVER_CARD",
                idx: idx
            })
        }
        this._lastHoveredCard = idx
    }

    handleMouseLeave(idx)
    {
        this.setState({ hoverIdx: undefined })
        setTimeout(() => {
            if (this._lastHoveredCard == idx) {
                this._lastHoveredCard = null
                this.props.send({
                    type: "HOVER_CARD",
                    idx: null
                })
            }
        }, 100)
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this._keyboardListener)
        clearInterval(this._updateHoveredCard)
    }

    render()
    {
        let cards = this.getCards()
        const cardDims = getCardDimensions(this.props.parentWidth, this.props.parentHeight)
        const cardWidth = cardDims.width
        const cardHeight = cardDims.height
        const borderRadius = 0.06 * cardHeight

        const translateXBase = cardWidth / 2

        let preMoveCoord = {
            left: 0,
            bot: 0
        }
        let cardPointerCoord = {
            left: 0,
            bot: 0
        }
        
        const cardViews = cards.map((c, idx) => {
            const translateX = (-cards.size / 2 + idx + .5) * translateXBase
            const playable = this.isCardPlayable(c)
            const animating = this.state.animatePlayCard == idx
            const isHighlighted = [ this.state.preMove, this.state.cardPointer ].includes(idx)
            const posLeft = animating
                ? window.__trickDisplay.x
                : this.props.parentWidth / 2 - cardWidth / 2 + translateX
            const posBot = animating
                ? window.__trickDisplay.y
                : -Math.abs(cardHeight / 3) + (playable ? cardHeight / 8 : 0) + (isHighlighted ? cardHeight / 10 : 0)
            const rotation = animating
                ? window.__trickDisplay.rotations[this.props.table.get("currentTrick").size]
                : 0
            const translation = animating
                ? window.__trickDisplay.translations[this.props.table.get("currentTrick").size].map(v => v + "px").join(",")
                : "0, 0"
                
            let isPremovedCard = this.state.preMove === idx
            if (isPremovedCard) {
                preMoveCoord.left = posLeft
                preMoveCoord.bot = posBot + cardHeight + 10
            }
            if (this.state.cardPointer === idx) {
                cardPointerCoord.left = posLeft
                cardPointerCoord.bot = posBot + cardHeight + 10 + (isPremovedCard ? 15 : 0)
            }

            const relativeIdx = cards.findIndex(ca => ca === c) == idx ? 1 : 2
            const highlightedColors = Array.from(this.props.highlightedCards.filter(index => index == idx).keys())
                .map(playerId => {
                    const target = this.props.table.get("players").find(p => p.get("id") == playerId)
                    return target ? target.get("color").toLowerCase() : ""
                })
            let background = highlightedColors.length
                ? (highlightedColors.length == 1 ? highlightedColors[0] : "linear-gradient(90deg, " + highlightedColors.map(c => "var(--player-color-" + c.toLowerCase() + ")").join(", ") + ")")
                : undefined

            return (
                <Card
                    ref={ ref => this._cardTopY = (this._cardTopY || !ReactDOM.findDOMNode(ref)) ? this._cardTopY : ReactDOM.findDOMNode(ref).getBoundingClientRect().y }
                    key={ c + "_" + relativeIdx }
                    cardId={ c }
                    size="hand"
                    className={ (animating ? "animating " : "") + (this.state.preMove === idx ? "pre-move" : "") }
                    onClick={ this.state.animatePlayCard != null ? undefined : () => {
                        if (playable) {
                            this.handlePlayCard(idx)
                        } else if (!this.props.isOwnTurn && this.props.isPlaying && getStorageValue(StorageFields.PRE_MOVES) !== "none") {
                            this.setState({ preMove: this.state.preMove === idx ? null : idx })
                        }
                    } }
                    onMouseEnter={ () => this.handleMouseEnter(idx) }
                    onMouseLeave={ () => this.handleMouseLeave(idx) }
                    style={{
                        position: "absolute",
                        left: posLeft,
                        bottom: posBot,
                        transformOrigin: "center",
                        transform: "translate(" + translation + ") rotate(" + rotation + "deg)",
                        zIndex: 13 - idx,
                        width: cardWidth,
                        height: cardHeight,
                        borderRadius: borderRadius,
                        background: background,
                        padding: background ? 5 : 0
                    }}
                />
            )
        })

        let preMoveIndicator = this.state.preMove != null ? (
            <div className={ "pre-move-indicator " + (this.state.preMoveStart ? "animating" : "") } style={{
                width: cardWidth * (2/3),
                height: 5,
                left: preMoveCoord.left + (cardWidth - (cardWidth * (2/3))) / 2,
                bottom: (this.state.hoverIdx == this.state.preMove) ? (5 + cardHeight + 10) : preMoveCoord.bot,
                animationName: this.state.preMoveStart ? "pre-move-animate" : undefined,
                animationDuration: this.state.preMoveStart ? (this.state.preMoveDelay + "ms") : undefined
            }} />
        ) : null;

        let cardPointerIndicator = this.state.cardPointer != null ? (
            <div className={ "card-pointer" } style={{
                width: 8,
                left: cardPointerCoord.left + (cardWidth - 8) / 2,
                bottom: (this.state.hoverIdx == this.state.cardPointer)
                    ? (5 + cardHeight + 10 + (this.state.hoverIdx == this.state.preMove ? 15 : 0))
                    : cardPointerCoord.bot,
            }} />
        ) : null

        return (
            <div 
                className={ "game-hand " + (this.props.className || "") }>
                { cardViews }
                { preMoveIndicator }
                { cardPointerIndicator }
            </div>
        )
    }

}

export default Hand
export { Hand }